import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {useQuery} from '@tanstack/react-query'
import ReactECharts from 'echarts-for-react'
import React, {useEffect, useMemo} from 'react'
import {useParams} from 'react-router-dom'
import {ReactComponent as BsFillHeartPulseFill} from '../../assets/icons/BsFillHeartPulseFill.svg'
import TranslateUtils from '../../i18n/TranslateUtils'

const ACTIVITY_ENDPOINT =
    process.env.REACT_APP_EXTERNAL_SERVICE_ENDPOINT +
    process.env.REACT_APP_EXTERNAL_SERVICE_ACTIVITY

const ECGQueryKey = 'ECG-DATA'

const ECGChart = data => {
    useSignals()
    const {translateKeys} = TranslateUtils()
    const {id: idString} = useParams()
    const id = useMemo(() => {
        return !!idString ? parseInt(idString) : null
    }, [idString])

    const getExternalServiceECGData = async () => {
        const responseData = await fetch(
            ACTIVITY_ENDPOINT + '/getExternalData',
            {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({}),
            },
        )
        if (!!responseData) {
            const ecgData = responseData.json()
            if (ecgData) {
                // setEcgData(ecgData)
                return ecgData
            }
        }
    }

    const {data: ecgData} = useQuery(
        [ECGQueryKey, id],
        () => getExternalServiceECGData(),
        {
            enabled: !!id,
        },
    )

    let x = [
        2097, 2204, 2131, 2008, 1943, 1964, 2029, 2072, 2064, 2020, 1981, 1975,
        1998, 2024, 2028, 2010, 1985, 1972, 1978, 1990, 1996, 1989, 1974, 1962,
        1960, 1964, 1968, 1967, 1959, 1952, 1949, 1951, 1954, 1956, 1954, 1952,
        1952, 1955, 1960, 1965, 1969, 1972, 1975, 1980, 1987, 1993, 1997, 2001,
        2004, 2007, 2010, 2013, 2014, 2015, 2015, 2015, 2015, 2015, 2014, 2013,
        2012, 2012, 2011, 2011, 2009, 2007, 2005, 2004, 2003, 2002, 2001, 2000,
        1998, 1997, 1996, 1995, 1994, 1992, 1991, 1990, 1989, 1988, 1987, 1986,
        1985, 1985, 1985, 1984, 1982, 1980, 1979, 1979, 1979, 1979, 1978, 1976,
        1975, 1975, 1975, 1976, 1975, 1974, 1973, 1973, 1974, 1976, 1976, 1976,
        1976, 1975, 1974, 1973, 1972, 1971, 1969, 1968, 1966, 1964, 1962, 1962,
        1962, 1964, 1966, 1966, 1964, 1963, 1963, 1963, 1964, 1964, 1961, 1959,
        1958, 1960, 1962, 1962, 1959, 1955, 1954, 1956, 1959, 1960, 1953, 1940,
        1929, 1932, 1958, 2010, 2078, 2148, 2204, 2236, 2242, 2223, 2187, 2139,
        2086, 2033, 1986, 1949, 1925, 1913, 1909, 1908, 1906, 1904, 1900, 1898,
        1897, 1898, 1899, 1899, 1898, 1897, 1897, 1897, 1898, 1898, 1897, 1895,
        1894, 1894, 1894, 1894, 1892, 1890, 1888, 1887, 1887, 1885, 1884, 1882,
        1881, 1882, 1883, 1885, 1885, 1886, 1887, 1889, 1892, 1895, 1898, 1902,
        1906, 1912, 1919, 1926, 1933, 1940, 1946, 1953, 1960, 1967, 1973, 1977,
        1981, 1984, 1988, 1991, 1993, 1994, 1995, 1997, 1998, 1999, 2000, 2000,
        2000, 2000, 2001, 2001, 2001, 2001, 2000, 2001, 2002, 2003, 2003, 2003,
        2003, 2003, 2004, 2004, 2005, 2004, 2004, 2004, 2004, 2005, 2005, 2006,
        2006, 2006, 2007, 2008, 2007, 2007, 2007, 2007, 2008, 2009, 2009, 2009,
        2009, 2009, 2011, 2012, 2013, 2012, 2012, 2013, 2015, 2017, 2018, 2018,
        2017, 2016, 2016, 2017, 2016, 2015, 2014, 2012, 2011, 2011, 2011, 2012,
        2013, 2014, 2015, 2015, 2015, 2015, 2015, 2015, 2015, 2014, 2013, 2013,
        2014, 2015, 2016, 2014, 2012, 2011, 2013, 2016, 2015, 2006, 1993, 1984,
        1992, 2026, 2084, 2156, 2225, 2275, 2299, 2296, 2272, 2234, 2185, 2132,
        2079, 2034, 2000, 1981, 1973, 1971, 1969, 1967, 1963, 1960, 1957, 1957,
        1956, 1956, 1955, 1955, 1954, 1953, 1952, 1951, 1951, 1950, 1950, 1949,
        1948, 1947, 1946, 1945, 1943, 1940, 1937, 1934, 1933, 1932, 1932, 1931,
        1930, 1929, 1929, 1930, 1930, 1931, 1932, 1934, 1938, 1942, 1946, 1950,
        1954, 1959, 1965, 1973, 1981, 1987, 1993, 1999, 2005, 2010, 2015, 2018,
        2020, 2021, 2023, 2026, 2028, 2029, 2030, 2030, 2030, 2030, 2030, 2029,
        2029, 2029, 2029, 2030, 2031, 2030, 2028, 2027, 2027, 2028, 2028, 2028,
        2027, 2026, 2025, 2026, 2026, 2027, 2026, 2024, 2023, 2023, 2024, 2024,
        2024, 2024, 2024, 2025, 2025, 2025, 2024, 2023, 2023, 2023, 2025, 2026,
        2026, 2026, 2027, 2028, 2031, 2032, 2033, 2032, 2032, 2032, 2033, 2032,
        2031, 2029, 2026, 2024, 2023, 2022, 2022, 2022, 2022, 2022, 2022, 2022,
        2022, 2023, 2023, 2023, 2022, 2021, 2020, 2021, 2023, 2023, 2021, 2018,
        2017, 2018, 2022, 2022, 2016, 2004, 1993, 1997, 2024, 2076, 2144, 2210,
        2261, 2287, 2289, 2272, 2240, 2198, 2149, 2098, 2051, 2015, 1991, 1980,
        1976, 1974, 1972, 1969, 1966, 1965, 1964, 1964, 1963, 1962, 1962, 1961,
        1960, 1960, 1960, 1959, 1959, 1958, 1957, 1956, 1955, 1954, 1953, 1952,
        1949, 1947, 1945, 1944, 1943, 1941, 1940, 1938, 1937, 1938, 1939, 1939,
        1940, 1941, 1943, 1946, 1951, 1955, 1960, 1964, 1970, 1977, 1985, 1992,
        1999, 2005, 2010, 2016, 2022, 2027, 2031, 2034, 2036, 2039, 2041, 2042,
        2043, 2043, 2044, 2044, 2045, 2045, 2044, 2043, 2043, 2044, 2045, 2045,
        2044, 2042, 2041, 2041, 2041, 2042, 2042, 2041, 2040, 2040, 2040, 2040,
        2040, 2039, 2039, 2039, 2039, 2039, 2039, 2039, 2039, 2039, 2039, 2039,
        2038, 2037, 2037, 2038, 2039, 2040, 2041, 2041, 2042, 2044, 2045, 2045,
        2044, 2043, 2042, 2041, 2040, 2039, 2036, 2034, 2033, 2034, 2035, 2036,
        2036, 2035, 2034, 2034, 2035, 2036, 2035, 2032, 2030, 2030, 2032, 2034,
        2034, 2032, 2029, 2027, 2029, 2032, 2031, 2024, 2012, 2001, 2004, 2030,
        2081, 2152, 2225, 2283, 2315, 2317, 2296, 2258, 2210, 2158, 2106, 2058,
        2020, 1994, 1981, 1977, 1976, 1975, 1971, 1967, 1964, 1964, 1965, 1965,
        1964, 1962, 1962, 1962, 1962, 1962, 1961, 1960, 1959, 1958, 1957, 1956,
        1954, 1952, 1950, 1949, 1948, 1946, 1944, 1943, 1941, 1940, 1939, 1938,
        1937, 1937, 1938, 1940, 1942, 1943, 1945, 1948, 1951, 1956, 1962, 1968,
        1974, 1981, 1988, 1995, 2002, 2008, 2013, 2017, 2022, 2026, 2029, 2031,
        2032, 2032, 2034, 2036, 2037, 2038, 2037, 2037, 2037, 2038, 2038, 2038,
        2037, 2036, 2036, 2036, 2036, 2036, 2035, 2034, 2034, 2034, 2034, 2033,
        2032, 2032, 2032, 2033, 2033, 2032, 2031, 2030, 2029, 2029, 2029, 2029,
        2029, 2029, 2029, 2030, 2030, 2030, 2029, 2029, 2030, 2031, 2032, 2032,
        2033, 2033, 2034, 2035, 2035, 2035, 2033, 2033, 2033, 2032, 2031, 2029,
        2026, 2024, 2024, 2025, 2027, 2028, 2027, 2025, 2025, 2026, 2027, 2028,
        2027, 2025, 2023, 2024, 2025, 2027, 2026, 2023, 2021, 2020, 2022, 2025,
        2024, 2016, 2003, 1992, 1996, 2023, 2076, 2146, 2219, 2277, 2308, 2311,
        2289, 2250, 2202, 2149, 2097, 2048, 2010, 1985, 1973, 1970, 1969, 1968,
        1963, 1958, 1956, 1955, 1957, 1957, 1956, 1955, 1954, 1954, 1954, 1954,
        1953, 1951, 1950, 1949, 1949, 1948, 1947, 1945, 1943, 1941, 1940, 1939,
        1937, 1934, 1933, 1932, 1933, 1933, 1933, 1933, 1934, 1935, 1937, 1939,
        1941, 1944, 1948, 1953, 1958, 1963, 1969, 1975, 1982, 1989, 1996, 2002,
        2007, 2012, 2016, 2021, 2024, 2027, 2029, 2030, 2030, 2032, 2032, 2033,
        2033, 2032, 2033, 2033, 2034, 2034, 2033, 2033, 2032, 2032, 2032, 2032,
        2031, 2031, 2030, 2031, 2031, 2030, 2029, 2029, 2028, 2029, 2029, 2028,
        2027, 2027, 2027, 2027, 2027, 2027, 2027, 2027, 2027, 2028, 2028, 2027,
        2027, 2026, 2027, 2028, 2029, 2029, 2028, 2028, 2029, 2030, 2032, 2032,
        2032, 2031, 2031, 2031, 2031, 2030, 2029, 2027, 2025, 2024, 2023, 2022,
        2022, 2023, 2024, 2025, 2025, 2025, 2024, 2024, 2025, 2026, 2025, 2023,
        2021, 2021, 2023, 2024, 2023, 2021, 2018, 2018, 2021, 2023, 2019, 2008,
        1994, 1988, 2003, 2046, 2110, 2184, 2249, 2292, 2308, 2298, 2269, 2225,
        2173, 2118, 2066, 2025, 1995, 1977, 1970, 1968, 1967, 1965, 1962, 1958,
        1956, 1955, 1956, 1956, 1956, 1954, 1953, 1952, 1952, 1952, 1952, 1951,
        1949, 1947, 1946, 1946, 1945, 1944, 1942, 1939, 1938, 1937, 1937, 1935,
        1934, 1932, 1931, 1931, 1932, 1933, 1933, 1934, 1935, 1938, 1941, 1944,
        1948, 1952, 1957, 1963, 1970, 1977, 1984, 1990, 1996, 2003, 2009, 2015,
        2018, 2021, 2023, 2026, 2028, 2030, 2030, 2031, 2031, 2032, 2033, 2033,
        2033, 2032, 2032, 2032, 2033, 2032, 2031, 2030, 2030, 2030, 2030, 2030,
        2030, 2029, 2028, 2028, 2029, 2029, 2028, 2027, 2027, 2027, 2027, 2028,
        2028, 2027, 2026, 2026, 2026, 2026, 2026, 2026, 2027, 2028, 2028, 2028,
        2028, 2027, 2027, 2028, 2029, 2031, 2031, 2031, 2032, 2033, 2033, 2033,
        2032, 2031, 2029, 2029, 2028, 2026, 2024, 2021, 2020, 2021, 2023, 2026,
        2026, 2025, 2023, 2024, 2025, 2027, 2027, 2025, 2022, 2021, 2023, 2025,
        2026, 2023, 2019, 2017, 2018, 2021, 2023, 2017, 2005, 1991, 1988, 2007,
        2051, 2117, 2190, 2254, 2296, 2309, 2296, 2263, 2217, 2165, 2111, 2061,
        2020, 1991, 1975, 1969, 1969, 1968, 1965, 1961, 1957, 1955, 1956, 1957,
        1957, 1956, 1954, 1953, 1953, 1954, 1954, 1952, 1950, 1948, 1947, 1947,
        1947, 1945, 1942, 1940, 1938, 1937, 1936, 1934, 1932, 1930, 1930, 1930,
        1931, 1931, 1930, 1930, 1932, 1934, 1937, 1940, 1943, 1946, 1951, 1958,
        1964, 1970, 1976, 1983, 1990, 1997, 2003, 2008, 2012, 2015, 2018, 2022,
        2025, 2026, 2027, 2028, 2029, 2030, 2031, 2031, 2030, 2030, 2030, 2030,
        2031, 2031, 2029, 2028, 2027, 2028, 2028, 2028, 2027, 2026, 2026, 2027,
        2028, 2028, 2027, 2026, 2025, 2025, 2026, 2026, 2025, 2024, 2024, 2024,
        2025, 2026, 2026, 2025, 2024, 2025, 2026, 2026, 2026, 2025, 2024, 2025,
        2027, 2029, 2030, 2030, 2030, 2030, 2031, 2032, 2032, 2031, 2030, 2029,
        2027, 2025, 2023, 2021, 2020, 2021, 2023, 2025, 2025, 2023, 2022, 2022,
        2023, 2025, 2025, 2023, 2021, 2020, 2022, 2024, 2024, 2021, 2017, 2016,
        2018, 2023, 2024, 2017, 2003, 1989, 1988, 2010, 2056, 2121, 2191, 2251,
        2289, 2300, 2287, 2255, 2210, 2158, 2105, 2057, 2018, 1992, 1977, 1972,
        1970, 1968, 1965, 1961, 1958, 1956, 1957, 1957, 1956, 1954, 1952, 1951,
        1952, 1953, 1953, 1952, 1951, 1950, 1949, 1949, 1948, 1946, 1943, 1941,
        1940, 1939, 1938, 1936, 1933, 1931, 1931, 1931, 1931, 1931, 1931, 1932,
        1933, 1936, 1938, 1940, 1942, 1946, 1951, 1959, 1967, 1974, 1981, 1987,
        1993, 2000, 2007, 2012, 2016, 2020, 2023, 2025, 2028, 2030, 2031, 2031,
        2032, 2033, 2034, 2033, 2033, 2033, 2033, 2034, 2034, 2034, 2033, 2033,
        2033, 2033, 2034, 2034, 2033, 2031, 2031, 2031, 2031, 2031, 2030, 2030,
        2030, 2031, 2031, 2031, 2030, 2029, 2029, 2030, 2031, 2031, 2031, 2031,
        2031, 2031, 2032, 2032, 2032, 2032, 2033, 2035, 2037, 2038, 2039, 2039,
        2039, 2039, 2039, 2039, 2038, 2036, 2035, 2033, 2032, 2030, 2029, 2029,
        2030, 2032, 2032, 2032, 2031, 2030, 2031, 2032, 2032, 2030, 2028, 2028,
        2029, 2032, 2032, 2030, 2027, 2025, 2027, 2030, 2031, 2023, 2009, 1998,
        2003, 2033, 2089, 2160, 2231, 2285, 2312, 2311, 2289, 2250, 2202, 2150,
        2098, 2053, 2018, 1995, 1983, 1978, 1977, 1976, 1973, 1970, 1967, 1965,
        1965, 1965, 1965, 1964, 1963, 1962, 1961, 1962, 1962, 1961, 1960, 1957,
        1956, 1955, 1955, 1954, 1952, 1950, 1948, 1947, 1946, 1945, 1943, 1941,
        1940, 1940, 1941, 1942, 1942, 1942, 1943, 1946, 1949, 1952, 1956, 1960,
        1965, 1971, 1978, 1985, 1991, 1997, 2002, 2008, 2015, 2020, 2024, 2026,
        2028, 2030, 2033, 2036, 2037, 2037, 2037, 2038, 2039, 2039, 2039, 2038,
        2037, 2037, 2037, 2037, 2037, 2036, 2035, 2035, 2035, 2036, 2036, 2035,
        2034, 2033, 2034, 2034, 2034, 2033, 2032, 2032, 2032, 2033, 2033, 2032,
        2031, 2031, 2032, 2032, 2032, 2032, 2031, 2031, 2033, 2034, 2035, 2035,
        2035, 2036, 2037, 2038, 2038, 2037, 2036, 2035, 2034, 2033, 2031, 2029,
        2027, 2027, 2027, 2029, 2029, 2029, 2028, 2027, 2028, 2029, 2030, 2029,
        2027, 2026, 2026, 2026, 2027, 2026, 2024, 2021, 2020, 2022, 2025, 2025,
        2020, 2010, 1999, 1996, 2011, 2048, 2106, 2176, 2242, 2290, 2311, 2305,
        2274, 2228, 2174, 2119, 2068, 2026, 1995, 1977, 1969, 1968, 1967, 1964,
        1960, 1957, 1955, 1955, 1956, 1956, 1954, 1952, 1951, 1951, 1952, 1951,
        1949, 1947, 1946, 1945, 1945, 1944, 1941, 1938, 1936, 1935, 1934, 1932,
        1930, 1928, 1926, 1926, 1925, 1925, 1925, 1924, 1924, 1926, 1928, 1930,
        1932, 1934, 1938, 1943, 1950, 1956, 1961, 1966, 1971, 1978, 1985, 1991,
        1996, 1999, 2003, 2006, 2009, 2012, 2013, 2013, 2013, 2014, 2016, 2016,
        2016, 2015, 2014, 2014, 2015, 2016, 2015, 2014, 2013, 2013, 2013, 2013,
        2013, 2011, 2010, 2010, 2011, 2011, 2011, 2009, 2008, 2008, 2009, 2009,
        2009, 2008, 2007, 2006, 2006, 2007, 2007, 2006, 2005, 2006, 2007, 2008,
        2009, 2009, 2009, 2010, 2011, 2012, 2012, 2011, 2009, 2009, 2008, 2008,
        2007, 2005, 2002, 2000, 2000, 2002, 2004, 2004, 2004, 2002, 2002, 2003,
        2004, 2005, 2004, 2002, 2001, 2000, 2001, 2002, 2001, 1999, 1997, 1996,
        1998, 2000, 2000, 1993, 1981, 1970, 1970, 1994, 2043, 2112, 2187, 2250,
        2288, 2295, 2275, 2237, 2188, 2133, 2079, 2030, 1990, 1963, 1950, 1946,
        1946, 1944, 1940, 1936, 1933, 1933, 1934, 1935, 1934, 1932, 1931, 1931,
        1932, 1932, 1931, 1929, 1928, 1927, 1927, 1926, 1924, 1922, 1921, 1920,
        1920, 1919, 1917, 1915, 1913, 1913, 1913, 1913, 1913, 1913, 1914, 1916,
        1918, 1921, 1923, 1926, 1929, 1935, 1941, 1947, 1953, 1959, 1965, 1972,
        1980, 1986, 1992, 1996, 2000, 2005, 2009, 2013, 2015, 2015, 2016, 2017,
        2019, 2021, 2021, 2021, 2020, 2020, 2020, 2020, 2019, 2019, 2019, 2020,
        2021, 2022, 2021, 2020, 2019, 2019, 2020, 2021, 2022, 2021, 2020, 2020,
        2020, 2021, 2021, 2021, 2020, 2021, 2021, 2022, 2023, 2023, 2022, 2023,
        2024, 2025, 2025, 2025, 2025, 2027, 2029, 2031, 2031, 2031, 2029, 2029,
        2029, 2029, 2029, 2028, 2026, 2024, 2023, 2024, 2025, 2026, 2027, 2028,
        2028, 2028, 2029, 2030, 2030, 2031, 2030, 2030, 2029, 2029, 2031, 2032,
        2031, 2030, 2028, 2028, 2030, 2032, 2029, 2020, 2007, 2000, 2012, 2051,
        2116, 2193, 2263, 2312, 2330, 2321, 2290, 2245, 2192, 2136, 2083, 2040,
        2009, 1993, 1986, 1984, 1983, 1980, 1976, 1974, 1973, 1973, 1972, 1972,
        1971, 1970, 1970, 1971, 1970, 1969, 1968, 1968, 1967, 1966, 1965, 1963,
        1962, 1961, 1960, 1958, 1956, 1955, 1953, 1953, 1952, 1951, 1950, 1949,
        1949, 1951, 1952, 1954, 1955, 1956, 1959, 1963, 1968, 1973, 1978, 1983,
        1990, 1997, 2005, 2012, 2017, 2022, 2027, 2033, 2038, 2042, 2044, 2046,
        2047, 2048, 2050, 2050, 2050, 2049, 2049, 2050, 2052, 2052, 2051, 2050,
        2049, 2048, 2049, 2050, 2049, 2048, 2048, 2048, 2048, 2048, 2048, 2047,
        2046, 2046, 2047, 2048, 2047, 2046, 2045, 2045, 2046, 2047, 2047, 2046,
        2045, 2045, 2046, 2047, 2047, 2047, 2046, 2046, 2047, 2048, 2050, 2050,
        2050, 2051, 2051, 2051, 2050, 2049, 2047, 2046, 2045, 2045, 2044, 2042,
        2042, 2042, 2044, 2045, 2046, 2044, 2043, 2042, 2043, 2044, 2043, 2041,
        2039, 2039, 2041, 2043, 2043, 2040, 2037, 2036, 2039, 2043, 2041, 2032,
        2017, 2007, 2013, 2044, 2099, 2169, 2239, 2292, 2322, 2325, 2305, 2267,
        2216, 2160, 2106, 2059, 2025, 2003, 1992, 1988, 1986, 1983, 1979, 1976,
        1973, 1973, 1974, 1975, 1974, 1973, 1972, 1971, 1971, 1971, 1970, 1969,
        1967, 1965, 1964, 1963, 1962, 1960, 1958, 1955, 1953, 1952, 1951, 1949,
        1947, 1945, 1944, 1944, 1945, 1946, 1946, 1946, 1947, 1950, 1953, 1956,
        1960, 1963, 1968, 1975, 1983, 1990, 1996, 2001, 2007, 2013, 2019, 2024,
        2028, 2031, 2033, 2037, 2040, 2042, 2043, 2042, 2042, 2043, 2044, 2045,
        2045, 2043, 2042, 2042, 2042, 2043, 2043, 2042, 2041, 2041, 2041, 2041,
        2041, 2040, 2039, 2039, 2039, 2040, 2039, 2038, 2036, 2036, 2037, 2038,
        2039, 2038, 2036, 2036, 2036, 2036, 2037, 2037, 2037, 2037, 2037, 2038,
        2037, 2037, 2037, 2038, 2040, 2042, 2043, 2043, 2042, 2041, 2041, 2042,
        2042, 2041, 2039, 2037, 2035, 2033, 2033, 2032, 2033, 2033, 2034, 2033,
        2032, 2032, 2032, 2033, 2034, 2033, 2032, 2030, 2029, 2031, 2033, 2033,
        2030, 2027, 2026, 2029, 2032, 2031, 2022, 2008, 1999, 2009, 2044, 2101,
        2171, 2236, 2282, 2304, 2301, 2279, 2242, 2194, 2141, 2088, 2044, 2012,
        1993, 1984, 1981, 1979, 1976, 1973, 1969, 1968, 1967, 1968, 1968, 1968,
        1967, 1965, 1964, 1963, 1963, 1964, 1963, 1962, 1961, 1960, 1959, 1958,
        1956, 1954, 1952, 1950, 1948, 1947, 1946, 1945, 1944, 1943, 1942, 1943,
        1943, 1944, 1944, 1946, 1949, 1952, 1956, 1959, 1963, 1968, 1974, 1982,
        1989, 1995, 2001, 2006, 2012, 2018, 2023, 2027, 2029, 2032, 2034, 2037,
        2039, 2039, 2039, 2040, 2040, 2041, 2042, 2041, 2040, 2039, 2039, 2039,
        2040, 2039, 2038, 2037, 2037, 2037, 2037, 2037, 2036, 2035, 2036, 2036,
        2037, 2037, 2036, 2035, 2035, 2035, 2036, 2035, 2034, 2032, 2031, 2032,
        2033, 2034, 2035, 2035, 2035, 2035, 2036, 2036, 2036, 2036, 2036, 2037,
        2037, 2037, 2037, 2037, 2038, 2040, 2041, 2040, 2039, 2037, 2036, 2036,
        2035, 2034, 2032, 2030, 2029, 2029, 2030, 2031, 2031, 2031, 2030, 2031,
        2031, 2032, 2032, 2031, 2029, 2028, 2028, 2029, 2030, 2030, 2028, 2026,
        2026, 2027, 2029, 2028, 2021, 2009, 1998, 2000, 2026, 2076, 2146, 2219,
        2278, 2310, 2313, 2292, 2255, 2209, 2157, 2105, 2055, 2017, 1990, 1978,
        1975, 1974, 1972, 1967, 1963, 1960, 1960, 1961, 1961, 1960, 1958, 1957,
        1957, 1957, 1956, 1955, 1954, 1953, 1953, 1953, 1951, 1949, 1947, 1945,
        1945, 1944, 1942, 1940, 1938, 1937, 1937, 1936, 1936, 1935, 1935, 1936,
        1938, 1939, 1941, 1942, 1944, 1948, 1953, 1958, 1964, 1969, 1974, 1981,
        1988, 1995, 2001, 2006, 2010, 2015, 2020, 2024, 2027, 2028, 2029, 2030,
        2031, 2033, 2033, 2033, 2033, 2033, 2033, 2034, 2034, 2033, 2032, 2031,
        2032, 2032, 2032, 2031, 2030, 2029, 2030, 2030, 2030, 2029, 2028, 2027,
        2027, 2027, 2027, 2027, 2026, 2026, 2026, 2027, 2028, 2028, 2027, 2027,
        2027, 2028, 2029, 2028, 2028, 2027, 2028, 2029, 2030, 2030, 2029, 2028,
        2029, 2030, 2030, 2030, 2029, 2029, 2029, 2030, 2031, 2031, 2031, 2031,
        2032, 2032, 2032, 2032, 2030, 2029, 2028, 2027, 2025, 2024, 2022, 2021,
        2022, 2024, 2025, 2025, 2024, 2023, 2024, 2025, 2026, 2026, 2024, 2022,
        2021, 2022, 2024, 2026, 2025, 2021, 2019, 2019, 2023, 2025, 2022, 2012,
        1999, 1992, 2003, 2037, 2094, 2164, 2231, 2281, 2304, 2301, 2276, 2235,
        2187, 2134, 2082, 2037, 2003, 1982, 1973, 1971, 1971, 1968, 1963, 1958,
        1955, 1955, 1957, 1958, 1957, 1955, 1954, 1954, 1954, 1955, 1954, 1952,
        1950, 1949, 1949, 1949, 1947, 1946, 1944, 1942, 1941, 1940, 1937, 1935,
        1934, 1933, 1934, 1934, 1934, 1933, 1933, 1935, 1937, 1939, 1941, 1944,
        1947, 1952, 1957, 1963, 1969, 1975, 1981, 1988, 1994, 2000, 2006, 2011,
        2016, 2020, 2024, 2027, 2029, 2029, 2030, 2031, 2033, 2034, 2034, 2033,
        2033, 2033, 2033, 2033, 2033, 2032, 2031, 2032, 2032, 2032, 2031, 2030,
        2030, 2029, 2030, 2029, 2028, 2027, 2026, 2026, 2027, 2027, 2027, 2026,
        2026, 2026, 2027, 2027, 2027, 2026, 2026, 2027, 2028, 2028, 2028, 2028,
        2027, 2028, 2028, 2028, 2027, 2027, 2027, 2027, 2028, 2028, 2028, 2027,
        2027, 2027, 2028, 2029, 2029, 2028, 2027, 2027, 2028, 2030, 2030, 2030,
        2030, 2030, 2030, 2029, 2027, 2025, 2024, 2023, 2022, 2022, 2021, 2020,
        2020, 2022, 2023, 2024, 2023, 2022, 2021, 2022, 2024, 2025, 2024, 2022,
        2020, 2019, 2021, 2023, 2023, 2021, 2018, 2018, 2020, 2023, 2022, 2014,
        2001, 1992, 1997, 2026, 2078, 2146, 2214, 2268, 2296, 2298, 2277, 2240,
        2193, 2141, 2089, 2043, 2007, 1984, 1973, 1970, 1970, 1969, 1965, 1961,
        1958, 1958, 1958, 1959, 1957, 1955, 1954, 1953, 1953, 1953, 1952, 1950,
        1949, 1948, 1948, 1947, 1946, 1944, 1942, 1941, 1940, 1939, 1937, 1935,
        1934, 1933, 1933, 1934, 1934, 1933, 1933, 1934, 1936, 1938, 1940, 1941,
        1944, 1949, 1955, 1961, 1967, 1972, 1977, 1984, 1991, 1998, 2005, 2009,
        2013, 2017, 2021, 2025, 2028, 2029, 2029, 2030, 2030, 2030, 2030, 2030,
        2029, 2030, 2030, 2031, 2030, 2029, 2029, 2029, 2029, 2029, 2029, 2027,
        2026, 2024, 2024, 2024, 2024, 2025, 2025, 2025, 2025, 2025, 2024, 2022,
        2021, 2020, 2020, 2021, 2021, 2021, 2021, 2020, 2020, 2020, 2019, 2019,
        2018, 2019, 2019, 2020, 2020, 2019, 2018, 2018, 2018, 2019, 2019, 2018,
        2018, 2019, 2020, 2021, 2021, 2021, 2022, 2022, 2022, 2020, 2018, 2015,
        2013, 2011, 2010, 2010, 2010, 2010, 2010, 2010, 2011, 2010, 2009, 2009,
        2009, 2009, 2009, 2008, 2007, 2005, 2006, 2007, 2007, 2006, 2003, 2000,
        2000, 2003, 2004, 1999, 1987, 1974, 1973, 1995, 2042, 2107, 2176, 2232,
        2266, 2274, 2260, 2229, 2185, 2134, 2081, 2033, 1994, 1969, 1956, 1951,
        1949, 1946, 1943, 1940, 1937, 1936, 1936, 1935, 1935, 1934, 1933, 1932,
        1931, 1930, 1930, 1929, 1928, 1926, 1925, 1924, 1924, 1923, 1921, 1919,
        1916, 1914, 1912, 1911, 1909, 1907, 1905, 1905, 1905, 1906, 1906, 1907,
        1907, 1909, 1911, 1914, 1918, 1922, 1926, 1932, 1938, 1945, 1951, 1957,
        1963, 1969, 1976, 1982, 1986, 1990, 1992, 1995, 1997, 1999, 2000, 2001,
        2001, 2002, 2003, 2004, 2004, 2004, 2003, 2002, 2003, 2004, 2004, 2004,
        2003, 2002, 2003, 2003, 2003, 2002, 2001, 2000, 2001, 2001, 2002, 2001,
        2001, 2001, 2001, 2002, 2002, 2002, 2001, 2001, 2002, 2003, 2004, 2004,
        2004, 2004, 2005, 2006, 2007, 2007, 2007, 2007, 2008, 2008, 2009, 2010,
        2011, 2012, 2013, 2015, 2016, 2015, 2014, 2014, 2014, 2013, 2013, 2011,
        2009, 2007, 2007, 2008, 2009, 2010, 2010, 2010, 2010, 2012, 2013, 2014,
        2014, 2014, 2013, 2013, 2014, 2015, 2016, 2016, 2015, 2014, 2014, 2017,
        2019, 2018, 2011, 1999, 1989, 1992, 2018, 2070, 2142, 2216, 2275, 2306,
        2308, 2287, 2249, 2203, 2153, 2101, 2053, 2016, 1991, 1980, 1977, 1976,
        1975, 1972, 1968, 1966, 1966, 1967, 1967, 1966, 1966, 1966, 1967, 1967,
        1967, 1966, 1966, 1966, 1966, 1966, 1965, 1964, 1963, 1962, 1961, 1960,
        1958, 1957, 1956, 1955, 1955, 1955, 1954, 1954, 1955, 1957, 1959, 1961,
        1962, 1964, 1967, 1972, 1978, 1984, 1990, 1996, 2003, 2010, 2018, 2025,
        2031, 2037, 2042, 2048, 2052, 2055, 2058, 2060, 2062, 2064, 2066, 2067,
        2067, 2067, 2068, 2069, 2070, 2070, 2069, 2069, 2069, 2069, 2070, 2071,
        2071, 2070, 2070, 2070, 2070, 2070, 2069, 2068, 2068, 2068, 2068, 2068,
        2068, 2067, 2067, 2068, 2068, 2068, 2068, 2067, 2067, 2067, 2068, 2068,
        2068, 2067, 2067, 2068, 2069, 2069, 2069, 2069, 2069, 2071, 2072, 2073,
        2074, 2073, 2073, 2073, 2073, 2072, 2071, 2070, 2069, 2067, 2066, 2065,
        2064, 2064, 2066, 2067, 2068, 2067, 2066, 2066, 2066, 2067, 2067, 2066,
        2063, 2062, 2062, 2064, 2065, 2064, 2061, 2058, 2059, 2062, 2064, 2059,
        2047, 2032, 2026, 2041, 2083, 2146, 2219, 2283, 2326, 2343, 2334, 2304,
        2260, 2209, 2154, 2103, 2061, 2031, 2012, 2004, 2002, 2001, 1999, 1996,
        1992, 1990, 1989, 1989, 1989, 1988, 1986, 1984, 1983, 1983, 1983, 1983,
        1981, 1979, 1978, 1977, 1976, 1975, 1973, 1970, 1968, 1967, 1966, 1965,
        1963, 1960, 1958, 1957, 1957, 1958, 1958, 1958, 1959, 1961, 1964, 1967,
        1970, 1973, 1977, 1982, 1988, 1995, 2000, 2006, 2012, 2019, 2025, 2031,
        2035, 2038, 2040, 2043, 2047, 2048, 2050, 2049, 2049, 2049, 2051, 2051,
        2052, 2051, 2049, 2049, 2049, 2049, 2049, 2048, 2047, 2047, 2047, 2047,
        2047, 2046, 2044, 2043, 2042, 2042, 2041, 2040, 2040, 2041, 2041, 2041,
        2041, 2039, 2038, 2038, 2039, 2039, 2039, 2038, 2038, 2038, 2039, 2040,
        2040, 2039, 2038, 2037, 2038, 2040, 2041, 2040, 2039, 2038, 2037, 2037,
        2036, 2035, 2033, 2031, 2030, 2028, 2028, 2028, 2028, 2029, 2030, 2030,
        2029, 2028, 2028, 2028, 2029, 2028, 2027, 2025, 2025, 2027, 2028, 2027,
        2025, 2021, 2021, 2023, 2025, 2021, 2010, 1995, 1989, 2003, 2045, 2110,
        2185, 2252, 2297, 2313, 2303, 2273, 2229, 2176, 2121, 2069, 2026, 1996,
        1979, 1972, 1970, 1969, 1966, 1963, 1960, 1958, 1957, 1957, 1956, 1955,
        1954, 1952, 1951, 1951, 1951, 1951, 1950, 1948, 1946, 1945, 1945, 1944,
        1942, 1940, 1938, 1936, 1935, 1934, 1932, 1930, 1928, 1927, 1926, 1927,
        1929, 1929, 1930, 1930, 1932, 1935, 1939, 1943, 1947, 1952, 1958, 1965,
        1972, 1978, 1984, 1990, 1997, 2003, 2008, 2011, 2014, 2017, 2019, 2022,
        2023, 2024, 2024, 2024, 2024, 2025, 2026, 2025, 2024, 2023, 2022, 2023,
        2023, 2022, 2022, 2021, 2021, 2022, 2022, 2021, 2020, 2018, 2018, 2018,
        2018, 2018, 2017, 2016, 2016, 2016, 2017, 2017, 2016, 2015, 2015, 2015,
        2016, 2016, 2016, 2015, 2015, 2016, 2017, 2018, 2018, 2018, 2019, 2020,
        2021, 2021, 2020, 2018, 2018, 2018, 2019, 2017, 2014, 2011, 2009, 2009,
        2010, 2013, 2014, 2013, 2012, 2012, 2013, 2014, 2014, 2013, 2011, 2010,
        2010, 2011, 2012, 2012, 2010, 2008, 2008, 2009, 2011, 2010, 2003, 1991,
        1979, 1979, 2001, 2048, 2116, 2189, 2251, 2289, 2297, 2279, 2244, 2197,
        2145, 2092, 2044, 2004, 1977, 1964, 1960, 1959, 1957, 1954, 1949, 1947,
        1947, 1949, 1948, 1946, 1944, 1942, 1943, 1944, 1944, 1943, 1941, 1939,
        1938, 1938, 1937, 1936, 1934, 1933, 1932, 1931, 1929, 1926, 1923, 1921,
        1921, 1921, 1920, 1919, 1918, 1918, 1919, 1923, 1926, 1928, 1931, 1934,
        1938, 1944, 1951, 1956, 1962, 1968, 1975, 1983, 1990, 1996, 2001, 2004,
        2008, 2011, 2014, 2016, 2018, 2019, 2021, 2022, 2022, 2022, 2022, 2022,
        2023, 2024, 2024, 2023, 2022, 2020, 2021, 2021, 2022, 2022, 2021, 2020,
        2020, 2020, 2020, 2020, 2019, 2018, 2018, 2019, 2020, 2020, 2019, 2017,
        2017, 2018, 2019, 2020, 2019, 2019, 2019, 2019, 2020, 2021, 2021, 2020,
        2020, 2021, 2023, 2024, 2025, 2026, 2025, 2024, 2023, 2023, 2022, 2021,
        2021, 2020, 2018, 2016, 2015, 2015, 2017, 2018, 2019, 2019, 2018, 2017,
        2018, 2019, 2019, 2018, 2016, 2015, 2016, 2018, 2018, 2016, 2013, 2012,
        2014, 2017, 2017, 2009, 1994, 1983, 1989, 2019, 2074, 2144, 2212, 2263,
        2289, 2290, 2269, 2233, 2186, 2133, 2081, 2036, 2002, 1982, 1971, 1967,
        1965, 1963, 1961, 1958, 1956, 1955, 1955, 1955, 1955, 1955, 1954, 1954,
        1953, 1953, 1954, 1954, 1953, 1952, 1950, 1950, 1949, 1948, 1946, 1944,
        1942, 1941, 1940, 1939, 1937, 1935, 1934, 1934, 1935, 1936, 1937, 1938,
        1939, 1941, 1945, 1949, 1954, 1958, 1962, 1968, 1975, 1983, 1990, 1997,
        2002, 2008, 2014, 2020, 2024, 2027, 2029, 2032, 2034, 2037, 2039, 2039,
        2039, 2040, 2041, 2042, 2042, 2042, 2041, 2041, 2041, 2042, 2042, 2041,
        2040, 2039, 2039, 2040, 2040, 2039, 2037, 2037, 2037, 2037, 2038, 2037,
        2037, 2036, 2036, 2037, 2037, 2037, 2036, 2036, 2037, 2038, 2039, 2039,
        2038, 2037, 2037, 2038, 2039, 2039, 2039, 2038, 2038, 2040, 2042, 2043,
        2043, 2042, 2042, 2042, 2042, 2042, 2040, 2039, 2038, 2037, 2036, 2035,
        2034, 2034, 2035, 2037, 2037, 2036, 2034, 2033, 2034, 2036, 2038, 2038,
        2036, 2033, 2033, 2034, 2036, 2036, 2033, 2029, 2028, 2031, 2035, 2033,
        2024, 2010, 2002, 2011, 2047, 2106, 2178, 2246, 2296, 2319, 2314, 2288,
        2247, 2197, 2144, 2092, 2047, 2013, 1991, 1981, 1978, 1978, 1977, 1974,
        1969, 1966, 1966, 1966, 1967, 1966, 1965, 1963, 1962, 1962, 1963, 1963,
        1961, 1959, 1958, 1957, 1956, 1956, 1954, 1951, 1949, 1948, 1947, 1946,
        1945, 1942, 1940, 1940, 1940, 1941, 1941, 1941, 1941, 1942, 1945, 1948,
        1951, 1954, 1957, 1962, 1969, 1976, 1983, 1989, 1995, 2001, 2008, 2015,
        2021, 2024, 2026, 2029, 2032, 2036, 2038, 2039, 2038, 2038, 2039, 2041,
        2042, 2042, 2041, 2040, 2040, 2041, 2041, 2040, 2039, 2037, 2037, 2038,
        2039, 2039, 2038, 2037, 2036, 2036, 2037, 2037, 2035, 2034, 2034, 2034,
        2034, 2034, 2033, 2032, 2033, 2034, 2035, 2035, 2034, 2033, 2033, 2034,
        2036, 2036, 2035, 2034, 2033, 2033, 2035, 2035, 2035, 2034, 2034, 2034,
        2035, 2036, 2036, 2036, 2037, 2038, 2039, 2039, 2039, 2037, 2035, 2035,
        2035, 2034, 2033, 2030, 2029, 2028, 2029, 2031, 2032, 2031, 2030, 2029,
        2029, 2030, 2031, 2030, 2029, 2027, 2027, 2027, 2029, 2029, 2028, 2026,
        2025, 2024, 2026, 2028, 2027, 2019, 2008, 1999, 2003, 2031, 2081, 2150,
        2219, 2274, 2303, 2305, 2284, 2249, 2204, 2153, 2101, 2052, 2014, 1990,
        1979, 1977, 1977, 1975, 1970, 1965, 1963, 1964, 1965, 1964, 1962, 1960,
        1960, 1961, 1962, 1962, 1960, 1958, 1956, 1956, 1956, 1956, 1954, 1951,
        1949, 1948, 1947, 1946, 1944, 1941, 1940, 1939, 1939, 1939, 1939, 1939,
        1939, 1941, 1944, 1946, 1947, 1949, 1951, 1955, 1961, 1967, 1973, 1979,
        1986, 1993, 2001, 2007, 2012, 2016, 2020, 2025, 2030, 2033, 2035, 2036,
        2036, 2037, 2039, 2040, 2040, 2040, 2039, 2039, 2040, 2041, 2040, 2039,
        2039, 2039, 2040, 2041, 2040, 2039, 2038, 2037, 2038, 2039, 2039, 2038,
        2036, 2035, 2036, 2036, 2036, 2036, 2035, 2035, 2036, 2036, 2036, 2035,
        2034, 2034, 2035, 2036, 2037, 2036, 2035, 2035, 2036, 2037, 2037, 2037,
        2036, 2035, 2036, 2037, 2038, 2038, 2036, 2036, 2036, 2037, 2037, 2037,
        2036, 2035, 2036, 2038, 2039, 2039, 2038, 2036, 2035, 2035, 2035, 2034,
        2031, 2029, 2028, 2028, 2029, 2030, 2030, 2030, 2030, 2031, 2032, 2031,
        2030, 2030, 2031, 2032, 2032, 2030, 2028, 2027, 2028, 2030, 2031, 2029,
        2026, 2025, 2026, 2029, 2028, 2020, 2007, 1998, 2008, 2043, 2102, 2172,
        2238, 2284, 2304, 2299, 2275, 2238, 2190, 2137, 2085, 2041, 2008, 1989,
        1981, 1978, 1976, 1973, 1970, 1967, 1965, 1964, 1964, 1964, 1963, 1963,
        1962, 1961, 1960, 1959, 1959, 1958, 1956, 1955, 1953, 1952, 1952, 1950,
        1948, 1945, 1943, 1941, 1941, 1940, 1938, 1936, 1934, 1933, 1934, 1936,
        1937, 1938, 1938, 1940, 1943, 1947, 1951, 1954, 1958, 1963, 1969, 1976,
        1983, 1989, 1994, 1999, 2005, 2011, 2016, 2020, 2022, 2024, 2026, 2029,
        2030, 2031, 2031, 2031, 2031, 2033, 2034, 2033, 2032, 2031, 2031, 2031,
        2032, 2031, 2030, 2028, 2028, 2029, 2030, 2030, 2029, 2027, 2026, 2027,
        2028, 2028, 2027, 2026, 2026, 2027, 2027, 2027, 2026, 2025, 2025, 2025,
        2026, 2027, 2027, 2026, 2025, 2025, 2026, 2027, 2027, 2026, 2026, 2026,
        2027, 2027, 2026, 2026, 2026, 2026, 2027, 2026, 2024, 2022, 2022, 2023,
        2025, 2026, 2026, 2025, 2024, 2025, 2027, 2028, 2028, 2026, 2024, 2022,
        2021, 2020, 2019, 2018, 2016, 2016, 2017, 2019, 2020, 2020, 2020, 2020,
        2020, 2020, 2020, 2019, 2019, 2020, 2020, 2019, 2018, 2016, 2016, 2018,
        2020, 2019, 2017, 2014, 2012, 2015, 2018, 2016, 2007, 1994, 1986, 1997,
        2034, 2094, 2165, 2230, 2275, 2293, 2287, 2261, 2221, 2172, 2120, 2068,
        2025, 1993, 1974, 1966, 1963, 1962, 1961, 1958, 1955, 1953, 1952, 1952,
        1952, 1952, 1951, 1950, 1949, 1948, 1948, 1948, 1947, 1945, 1943, 1942,
        1941, 1941, 1939, 1937, 1935, 1934, 1933, 1932, 1931, 1929, 1927, 1925,
        1925, 1926, 1927, 1928, 1929, 1930, 1932, 1935, 1939, 1942, 1946, 1951,
        1957, 1963, 1969, 1975, 1981, 1986, 1993, 2000, 2006, 2010, 2013, 2016,
        2019, 2021, 2024, 2025, 2026, 2026, 2027, 2028, 2029, 2030, 2029, 2028,
        2028, 2029, 2030, 2030, 2029, 2028, 2027, 2028, 2028, 2028, 2027, 2026,
        2025, 2026, 2027, 2027, 2026, 2025, 2025, 2025, 2026, 2026, 2025, 2024,
        2023, 2023, 2024, 2025, 2025, 2024, 2023, 2024, 2025, 2026, 2026, 2026,
        2025, 2025, 2026, 2026, 2026, 2025, 2025, 2025, 2026, 2027, 2027, 2026,
        2026, 2026, 2026, 2026, 2026, 2026, 2027, 2028, 2030, 2030, 2029, 2026,
        2024, 2022, 2022, 2023, 2022, 2020, 2019, 2018, 2018, 2020, 2021, 2021,
        2022, 2022, 2022, 2023, 2023, 2022, 2022, 2022, 2021, 2020, 2020, 2021,
        2022, 2023, 2023, 2022, 2019, 2018, 2020, 2021, 2020, 2012, 2000, 1992,
        2002, 2035, 2090, 2158, 2221, 2267, 2288, 2286, 2265, 2229, 2183, 2131,
        2079, 2035, 2003, 1985, 1977, 1974, 1971, 1968, 1964, 1961, 1960, 1959,
        1958, 1957, 1957, 1957, 1958, 1958, 1956, 1955, 1954, 1954, 1954, 1954,
        1952, 1949, 1947, 1945, 1945, 1944, 1942, 1940, 1938, 1936, 1935, 1935,
        1933, 1933, 1932, 1933, 1935, 1936, 1936, 1937, 1939, 1943, 1947, 1952,
        1956, 1961, 1967, 1974, 1982, 1989, 1995, 2001, 2006, 2011, 2017, 2022,
        2026, 2028, 2030, 2032, 2034, 2035, 2036, 2035, 2035, 2035, 2037, 2038,
        2038, 2037, 2036, 2036, 2036, 2037, 2037, 2035, 2034, 2034, 2034, 2035,
        2035, 2035, 2034, 2034, 2034, 2034, 2034, 2034, 2033, 2033, 2033, 2034,
        2033, 2033, 2032, 2032, 2033, 2034, 2034, 2034, 2034, 2034, 2035, 2036,
        2036, 2035, 2035, 2035, 2035, 2036, 2036, 2035, 2034, 2034, 2035, 2036,
        2036, 2036, 2036, 2037, 2038, 2039, 2039, 2038, 2035, 2034, 2033, 2033,
        2033, 2031, 2030, 2029, 2029, 2031, 2032, 2032, 2032, 2032, 2032, 2032,
        2032, 2032, 2032, 2032, 2032, 2032, 2031, 2030, 2031, 2032, 2032, 2031,
        2029, 2027, 2028, 2031, 2031, 2026, 2015, 2003, 2003, 2025, 2073, 2141,
        2211, 2268, 2300, 2305, 2288, 2255, 2211, 2162, 2110, 2061, 2023, 1998,
        1984, 1979, 1977, 1975, 1971, 1968, 1966, 1964, 1964, 1963, 1963, 1962,
        1962, 1961, 1960, 1958, 1958, 1957, 1957, 1956, 1955, 1953, 1951, 1950,
        1949, 1947, 1945, 1942, 1940, 1939, 1938, 1937, 1936, 1935, 1934, 1935,
        1936, 1937, 1938, 1939, 1940, 1944, 1948, 1953, 1957, 1961, 1966, 1973,
        1981, 1988, 1995, 2000, 2005, 2011, 2016, 2021, 2024, 2026, 2027, 2029,
        2031, 2032, 2033, 2032, 2032, 2032, 2033, 2034, 2034, 2033, 2032, 2032,
        2033, 2033, 2033, 2032, 2031, 2031, 2031, 2031, 2031, 2030, 2028, 2027,
        2027, 2028, 2028, 2027, 2026, 2026, 2026, 2026, 2026, 2026, 2025, 2026,
        2026, 2027, 2026, 2025, 2025, 2025, 2025, 2026, 2026, 2025, 2024, 2024,
        2025, 2026, 2026, 2026, 2025, 2024, 2025, 2026, 2028, 2028, 2028, 2028,
        2027, 2026, 2025, 2024, 2022, 2021, 2020, 2020, 2019, 2017, 2017, 2017,
        2019, 2022, 2023, 2022, 2020, 2019, 2020, 2022, 2023, 2023, 2020, 2019,
        2019, 2021, 2023, 2023, 2020, 2016, 2015, 2018, 2021, 2021, 2012, 1998,
        1988, 1992, 2021, 2073, 2141, 2210, 2264, 2293, 2296, 2276, 2240, 2195,
        2144, 2093, 2046, 2009, 1984, 1971, 1967, 1967, 1966, 1962, 1958, 1955,
        1954, 1955, 1956, 1955, 1953, 1952, 1951, 1951, 1952, 1951, 1949, 1948,
        1947, 1947, 1946, 1945, 1943, 1941, 1939, 1938, 1937, 1936, 1934, 1932,
        1930, 1930, 1930, 1930, 1930, 1930, 1931, 1933, 1936, 1939, 1941, 1944,
        1948, 1953, 1959, 1966, 1972, 1978, 1985, 1992, 1999, 2005, 2010, 2014,
        2019, 2022, 2026, 2028, 2029, 2030, 2031, 2032, 2033, 2033, 2033, 2033,
        2033, 2034, 2035, 2035, 2034, 2032, 2032, 2032, 2032, 2032, 2031, 2031,
        2030, 2031, 2031, 2031, 2030, 2029, 2029, 2029, 2030, 2030, 2030, 2029,
        2029, 2029, 2029, 2029, 2029, 2028, 2028, 2028, 2029, 2029, 2029, 2029,
        2029, 2030, 2030, 2030, 2030, 2030, 2030, 2031, 2032, 2033, 2034, 2034,
        2034, 2034, 2034, 2033, 2032, 2031, 2030, 2029, 2027, 2026, 2024, 2023,
        2025, 2026, 2028, 2029, 2028, 2028, 2028, 2029, 2029, 2028, 2027, 2025,
        2025, 2027, 2029, 2029, 2026, 2023, 2021, 2023, 2027, 2027, 2019, 2006,
        1994, 1995, 2020, 2070, 2138, 2209, 2268, 2304, 2311, 2294, 2259, 2212,
        2160, 2106, 2058, 2020, 1994, 1980, 1976, 1975, 1974, 1971, 1967, 1964,
        1963, 1964, 1964, 1963, 1961, 1960, 1959, 1960, 1961, 1960, 1958, 1956,
        1955, 1954, 1954, 1953, 1951, 1948, 1947, 1946, 1945, 1943, 1941, 1939,
        1937, 1937, 1937, 1937, 1936, 1936, 1937, 1940, 1942, 1945, 1947, 1949,
        1953, 1958, 1965, 1972, 1978, 1984, 1991, 1998, 2005, 2011, 2016, 2020,
        2024, 2028, 2031, 2034, 2036, 2037, 2037, 2038, 2039, 2040, 2039, 2038,
        2038, 2038, 2039, 2039, 2038, 2037, 2037, 2037, 2037, 2037, 2036, 2035,
        2035, 2035, 2035, 2035, 2034, 2033, 2032, 2033, 2033, 2033, 2033, 2032,
        2032, 2031, 2032, 2032, 2032, 2032, 2032, 2032, 2032, 2032, 2032, 2032,
        2032, 2032, 2033, 2033, 2033, 2034, 2035, 2035, 2035, 2034, 2033, 2032,
        2032, 2032, 2032, 2031, 2028, 2025, 2024, 2024, 2026, 2027, 2028, 2028,
        2027, 2026, 2026, 2027, 2028, 2027, 2026, 2025, 2025, 2025, 2026, 2026,
        2024, 2022, 2021, 2022, 2024, 2024, 2018, 2006, 1994, 1994, 2015, 2061,
        2128, 2201, 2262, 2299, 2308, 2292, 2259, 2213, 2160, 2106, 2057, 2018,
        1993, 1980, 1976, 1973, 1970, 1966, 1962, 1961, 1961, 1962, 1962, 1960,
        1958, 1958, 1958, 1958, 1957, 1956, 1954, 1952, 1951, 1950, 1949, 1948,
        1946, 1945, 1943, 1942, 1940, 1939, 1937, 1936, 1934, 1933, 1932, 1931,
        1932, 1933, 1934, 1935, 1936, 1938, 1941, 1945, 1950, 1954, 1959, 1965,
        1971, 1979, 1986, 1993, 1999, 2004, 2009, 2014, 2019, 2023, 2025, 2027,
        2028, 2029, 2030, 2031, 2031, 2032, 2032, 2032, 2032, 2032, 2031, 2031,
        2030, 2030, 2030, 2030, 2030, 2030, 2029, 2028, 2027, 2026, 2026, 2025,
        2025, 2025, 2024, 2022, 2021, 2021, 2022, 2024, 2024, 2023, 2021, 2020,
        2020, 2021, 2021, 2021, 2020, 2020, 2021, 2022, 2022, 2023, 2023, 2024,
        2025, 2026, 2026, 2025, 2023, 2021, 2020, 2019, 2018, 2015, 2013, 2011,
        2011, 2012, 2013, 2013, 2011, 2010, 2010, 2011, 2012, 2011, 2008, 2006,
        2005, 2006, 2008, 2008, 2005, 2003, 2002, 2003, 2006, 2005, 1997, 1983,
        1971, 1972, 1995, 2042, 2107, 2177, 2236, 2272, 2281, 2264, 2229, 2183,
        2131, 2079, 2032, 1994, 1968, 1954, 1949, 1947, 1945, 1942, 1938, 1935,
        1935, 1935, 1935, 1933, 1931, 1929, 1929, 1929, 1929, 1928, 1927, 1925,
        1924, 1923, 1922, 1921, 1919, 1916, 1914, 1913, 1912, 1910, 1908, 1905,
        1904, 1903, 1903, 1903, 1903, 1903, 1904, 1906, 1908, 1910, 1912, 1916,
        1920, 1926, 1932, 1938, 1944, 1950, 1957, 1964, 1971, 1976, 1981, 1985,
        1989, 1992, 1995, 1997, 1998, 1999, 1999, 2001, 2002, 2002, 2002, 2001,
        2002, 2002, 2002, 2002, 2001, 2000, 2000, 2001, 2001, 2000, 1999, 1999,
        1998, 1998, 1998, 1998, 1998, 1997, 1998, 1998, 1998, 1998, 1997, 1997,
        1997, 1997, 1998, 1998, 1998, 1998, 1999, 1999, 2000, 2000, 2000, 2001,
        2003, 2005, 2006, 2006, 2005, 2005, 2005, 2005, 2004, 2003, 2001, 1999,
        1998, 1999, 2000, 2001, 2001, 2002, 2002, 2002, 2003, 2003, 2004, 2004,
        2004, 2004, 2003, 2004, 2004, 2005, 2005, 2004, 2003, 2002, 2004, 2006,
        2004, 1997, 1986, 1980, 1989, 2023, 2079, 2150, 2218, 2269, 2293, 2291,
        2266, 2226, 2176, 2122, 2070, 2027, 1996, 1978, 1970, 1968, 1966, 1964,
        1962, 1960, 1959, 1959, 1959, 1958, 1958, 1958, 1959, 1959, 1959, 1959,
        1959, 1959, 1959, 1958, 1957, 1957, 1956, 1955, 1954, 1952, 1951, 1949,
        1949, 1948, 1947, 1946, 1946, 1945, 1946, 1947, 1948, 1950, 1952, 1954,
        1958, 1961, 1964, 1968, 1972, 1979, 1987, 1995, 2003, 2010, 2015, 2021,
        2027, 2033, 2039, 2043, 2045, 2048, 2049, 2052, 2054, 2054, 2054, 2054,
        2055, 2056, 2057, 2058, 2058, 2057, 2057, 2057, 2057, 2057, 2057, 2056,
        2056, 2057, 2058, 2058, 2057, 2057, 2057, 2057, 2057, 2057, 2056, 2055,
        2055, 2056, 2056, 2056, 2056, 2056, 2056, 2057, 2058, 2058, 2057, 2057,
        2058, 2059, 2060, 2060, 2059, 2059, 2060, 2061, 2063, 2064, 2064, 2064,
        2064, 2064, 2064, 2063, 2062, 2062, 2061, 2060, 2058, 2056, 2055, 2054,
        2056, 2058, 2060, 2060, 2058, 2057, 2058, 2059, 2061, 2061, 2059, 2057,
        2056, 2058, 2060, 2060, 2058, 2054, 2053, 2056, 2059, 2059, 2052, 2038,
        2026, 2028, 2052, 2103, 2171, 2242, 2300, 2334, 2340, 2322, 2287, 2241,
        2189, 2137, 2088, 2049, 2022, 2008, 2003, 2003, 2002, 1998, 1994, 1990,
        1990, 1991, 1992, 1991, 1989, 1987, 1986, 1987, 1987, 1987, 1985, 1983,
        1981, 1981, 1980, 1979, 1977, 1975, 1973, 1972, 1970, 1969, 1966, 1964,
        1963, 1963, 1963, 1963, 1962, 1961, 1962, 1964, 1966, 1968, 1970, 1973,
        1977, 1982, 1988, 1994, 2000, 2005, 2011, 2018, 2025, 2030, 2035, 2039,
        2043, 2047, 2050, 2053, 2054, 2054, 2055, 2056, 2057, 2057, 2057, 2056,
        2056, 2057, 2057, 2057, 2056, 2055, 2054, 2055, 2055, 2055, 2054, 2053,
        2052, 2051, 2052, 2052, 2052, 2050, 2049, 2049, 2049, 2049, 2048, 2048,
        2048, 2048, 2049, 2049, 2049, 2048, 2048, 2048, 2048, 2048, 2048, 2048,
        2048, 2048, 2049, 2049, 2049, 2049, 2050, 2051, 2052, 2052, 2052, 2050,
        2049, 2048, 2048, 2048, 2046, 2043, 2041, 2040, 2040, 2041, 2042, 2043,
        2043, 2043, 2042, 2041, 2041, 2041, 2040, 2040, 2039, 2039, 2039, 2040,
        2039, 2038, 2036, 2034, 2034, 2036, 2037, 2033, 2022, 2009, 2004, 2018,
        2058, 2121, 2195, 2261, 2306, 2322, 2312, 2282, 2239, 2188, 2134, 2082,
        2039, 2009, 1992, 1985, 1982, 1981, 1977, 1974, 1971, 1969, 1969, 1969,
        1968, 1966, 1965, 1965, 1964, 1963, 1962, 1962, 1961, 1960, 1959, 1957,
        1956, 1955, 1954, 1952, 1950, 1949, 1947, 1945, 1944, 1943, 1941, 1940,
        1939, 1939, 1940, 1941, 1942, 1944, 1945, 1948, 1951, 1955, 1959, 1964,
        1969, 1976, 1982, 1989, 1995, 2000, 2006, 2012, 2018, 2022, 2025, 2028,
        2030, 2032, 2034, 2035, 2036, 2036, 2037, 2038, 2038, 2038, 2037, 2036,
        2035, 2035, 2036, 2036, 2035, 2033, 2032, 2032, 2032, 2033, 2032, 2031,
        2030, 2030, 2031, 2031, 2031, 2030, 2030, 2030, 2030, 2030, 2030, 2030,
        2029, 2030, 2030, 2031, 2030, 2030, 2029, 2029, 2030, 2031, 2031, 2031,
        2031, 2031, 2032, 2032, 2033, 2033, 2033, 2034, 2034, 2034, 2033, 2031,
        2030, 2029, 2028, 2027, 2025, 2023, 2022, 2022, 2024, 2026, 2026, 2026,
        2025, 2024, 2025, 2026, 2026, 2025, 2023, 2022, 2022, 2023, 2025, 2025,
        2023, 2020, 2019, 2020, 2022, 2021, 2014, 2002, 1991, 1992, 2016, 2065,
        2133, 2205, 2264, 2298, 2304, 2286, 2250, 2205, 2153, 2100, 2051, 2012,
        1986, 1974, 1970, 1969, 1967, 1963, 1959, 1957, 1957, 1957, 1956, 1955,
        1953, 1952, 1953, 1953, 1953, 1952, 1950, 1949, 1948, 1948, 1947, 1945,
        1943, 1941, 1940, 1939, 1938, 1936, 1934, 1932, 1931, 1930, 1930, 1929,
        1929, 1930, 1932, 1933, 1934, 1935, 1938, 1941, 1946, 1951, 1955, 1960,
        1966, 1974, 1982, 1989, 1994, 1998, 2002, 2007, 2012, 2017, 2020, 2022,
        2023, 2024, 2025, 2027, 2027, 2027, 2027, 2027, 2027, 2027, 2027, 2027,
        2026, 2026, 2026, 2026, 2025, 2025, 2024, 2024, 2024, 2024, 2024, 2024,
        2024, 2024, 2024, 2023, 2022, 2021, 2021, 2022, 2023, 2024, 2023, 2023,
        2022, 2023, 2023, 2024, 2023, 2023, 2022, 2023, 2024, 2024, 2024, 2024,
        2024, 2025, 2027, 2028, 2029, 2029, 2028, 2027, 2027, 2026, 2026, 2024,
        2023, 2021, 2019, 2018, 2017, 2017, 2018, 2020, 2021, 2021, 2020, 2019,
        2019, 2019, 2019, 2018, 2016, 2015, 2016, 2018, 2019, 2018, 2015, 2012,
        2013, 2016, 2018, 2013, 2002, 1989, 1987, 2005, 2049, 2112, 2181, 2240,
        2278, 2291, 2280, 2250, 2207, 2156, 2103, 2055, 2017, 1990, 1975, 1969,
        1967, 1965, 1963, 1959, 1956, 1955, 1954, 1954, 1954, 1954, 1953, 1952,
        1952, 1952, 1953, 1952, 1950, 1949, 1948, 1947, 1947, 1946, 1944, 1942,
        1940, 1938, 1937, 1936, 1935, 1933, 1932, 1932, 1933, 1934, 1934, 1934,
        1935, 1937, 1940, 1944, 1948, 1951, 1956, 1961, 1968, 1975, 1981, 1988,
        1994, 2001, 2007, 2013, 2018, 2022, 2025, 2028, 2031, 2033, 2034, 2035,
        2035, 2036, 2037, 2038, 2038, 2037, 2037, 2038, 2038, 2038, 2038, 2036,
        2036, 2036, 2036, 2037, 2037, 2036, 2035, 2034, 2034, 2034, 2034, 2034,
        2034, 2034, 2035, 2035, 2035, 2034, 2034, 2034, 2034, 2035, 2035, 2034,
        2033, 2034, 2035, 2036, 2037, 2036, 2036, 2037, 2038, 2040, 2041, 2041,
        2041, 2041, 2041, 2041, 2040, 2038, 2036, 2034, 2032, 2031, 2031, 2031,
        2031, 2033, 2034, 2034, 2033, 2032, 2032, 2033, 2034, 2033, 2032, 2030,
        2029, 2031, 2033, 2034, 2031, 2028, 2025, 2026, 2029, 2028, 2021, 2009,
        1999, 2005, 2036, 2091, 2162, 2233, 2287, 2315, 2315, 2292, 2252, 2203,
        2150, 2098, 2052, 2017, 1994, 1982, 1979, 1978, 1976, 1973, 1969, 1966,
        1964, 1964, 1965, 1965, 1964, 1963, 1962, 1962, 1962, 1962, 1961, 1959,
        1958, 1957, 1956, 1955, 1954, 1952, 1949, 1948, 1946, 1945, 1943, 1942,
        1941, 1941, 1942, 1943, 1943, 1943, 1944, 1945, 1948, 1951, 1954, 1958,
        1962, 1967, 1973, 1979, 1985, 1991, 1998, 2004, 2011, 2018, 2023, 2026,
        2029, 2032, 2035, 2037, 2039, 2039, 2039, 2039, 2040, 2041, 2041, 2041,
        2040, 2040, 2041, 2041, 2041, 2040, 2039, 2038, 2038, 2039, 2039, 2039,
        2038, 2037, 2036, 2036, 2036, 2035, 2034, 2034, 2033, 2033, 2033, 2032,
        2032, 2032, 2032, 2033, 2033, 2032, 2031, 2031, 2032, 2032, 2033, 2033,
        2033, 2033, 2035, 2036, 2036, 2036, 2035, 2034, 2034, 2034, 2033, 2032,
        2030, 2028, 2027, 2026, 2025, 2026, 2026, 2027, 2028, 2028, 2027, 2026,
        2026, 2027, 2027, 2026, 2024, 2023, 2023, 2025, 2026, 2025, 2022, 2020,
        2019, 2022, 2023, 2019, 2007, 1994, 1989, 2006, 2049, 2115, 2189, 2253,
        2295, 2309, 2296, 2264, 2219, 2167, 2112, 2062, 2021, 1993, 1976, 1970,
        1968, 1967, 1965, 1962, 1958, 1956, 1956, 1956, 1956, 1955, 1954, 1952,
        1951, 1951, 1951, 1951, 1950, 1948, 1947, 1946, 1945, 1945, 1943, 1941,
        1939, 1938, 1937, 1935, 1934, 1932, 1930, 1930, 1931, 1932, 1932, 1933,
        1934, 1935, 1937, 1940, 1943, 1947, 1951, 1957, 1963, 1969, 1975, 1982,
        1988, 1994, 2001, 2007, 2011, 2014, 2017, 2020, 2023, 2025, 2026, 2027,
        2027, 2027, 2028, 2029, 2030, 2029, 2029, 2028, 2028, 2027, 2027, 2027,
        2027, 2028, 2028, 2028, 2027, 2026, 2025, 2025, 2026, 2026, 2025, 2024,
        2024, 2024, 2025, 2025, 2024, 2024, 2023, 2023, 2024, 2024, 2025, 2024,
        2024, 2025, 2025, 2025, 2025, 2025, 2025, 2025, 2026, 2027, 2028, 2029,
        2030, 2030, 2030, 2029, 2028, 2028, 2027, 2027, 2025, 2023, 2021, 2020,
        2020, 2022, 2023, 2024, 2023, 2022, 2022, 2023, 2024, 2025, 2024, 2022,
        2020, 2020, 2022, 2023, 2023, 2020, 2018, 2017, 2019, 2022, 2021, 2013,
        2000, 1990, 1994, 2022, 2075, 2145, 2217, 2273, 2303, 2305, 2284, 2246,
        2198, 2145, 2092, 2045, 2008, 1985, 1974, 1970, 1970, 1967, 1963, 1959,
        1957, 1957, 1958, 1958, 1956, 1955, 1954, 1954, 1955, 1955, 1954, 1953,
        1952, 1951, 1950, 1949, 1948, 1946, 1945, 1944, 1942, 1940, 1938, 1937,
        1936, 1935, 1934, 1934, 1934, 1934, 1936, 1937, 1938, 1940, 1941, 1944,
        1948, 1953, 1959, 1964, 1970, 1976, 1983, 1989, 1996, 2001, 2007, 2012,
        2017, 2021, 2024, 2027, 2028, 2030, 2031, 2032, 2033, 2033, 2033, 2033,
        2033, 2033, 2033, 2032, 2032, 2032, 2032, 2032, 2032, 2031, 2030, 2030,
        2030, 2030, 2030, 2029, 2028, 2028, 2028, 2028, 2028, 2028, 2027, 2027,
        2027, 2028, 2028, 2027, 2027, 2027, 2027, 2027, 2028, 2028, 2028, 2028,
        2028, 2029, 2029, 2028, 2028, 2029, 2030, 2030, 2031, 2032, 2032, 2032,
        2032, 2031, 2030, 2029, 2028, 2028, 2027, 2025, 2024, 2022, 2023, 2024,
        2025, 2026, 2026, 2025, 2025, 2025, 2026, 2027, 2026, 2024, 2023, 2024,
        2025, 2026, 2026, 2023, 2021, 2020, 2023, 2025, 2023, 2015, 2001, 1992,
        1997, 2025, 2078, 2148, 2218, 2274, 2303, 2305, 2283, 2244, 2195, 2141,
        2089, 2043, 2008, 1985, 1975, 1972, 1971, 1969, 1965, 1961, 1959, 1958,
        1959, 1959, 1957, 1955, 1954, 1954, 1954, 1953, 1952, 1951, 1951, 1950,
        1950, 1949, 1947, 1945, 1943, 1941, 1940, 1938, 1936, 1935, 1934, 1934,
        1933, 1933, 1932, 1932, 1933, 1934, 1936, 1937, 1939, 1942, 1946, 1951,
        1955, 1960, 1965, 1971, 1977, 1984, 1991, 1997, 2002, 2007, 2012, 2016,
        2019, 2022, 2024, 2026, 2027, 2028, 2029, 2029, 2029, 2029, 2029, 2029,
        2029, 2029, 2028, 2027, 2027, 2027, 2027, 2027, 2027, 2027, 2027, 2026,
        2026, 2025, 2025, 2025, 2025, 2025, 2024, 2023, 2022, 2023, 2024, 2024,
        2024, 2023, 2022, 2022, 2023, 2024, 2025, 2026, 2026, 2026, 2026, 2026,
        2027, 2028, 2029, 2030, 2031, 2031, 2029, 2028, 2028, 2028, 2029, 2029,
        2027, 2025, 2022, 2022, 2022, 2023, 2024, 2024, 2023, 2022,
    ]

    const testData = useSignal(x)
    useEffect(() => {
        const timer = setInterval(() => {
            testData.value = [...x]
        }, 5000)
        return () => clearInterval(timer)
    }, [])

    const renderData = useMemo(() => {
        let data = []

        for (let i = 0; i < testData.value.length; i++) {
            let item = [i, testData.value[i] * 10]
            data.push(item)
        }

        return data
    }, [testData.value])

    const ecgOption = useMemo(() => {
        return {
            animation: true,
            grid: {
                top: 40,
                left: 50,
                right: 40,
                bottom: 50,
            },

            //X
            xAxis: {
                name: 'x',
                minorTick: {
                    show: true,
                },
                minorSplitLine: {
                    show: true,
                },
            },

            // Y
            yAxis: {
                name: 'y',
                min: -50000,
                max: 50000,
                minorTick: {
                    show: true,
                },
                minorSplitLine: {
                    show: true,
                },
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    animation: true,
                    label: {
                        backgroundColor: '#f9f9f9',
                        borderColor: 'darkcyan',
                        borderWidth: 1,
                        shadowBlur: 0,
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        color: 'darkcyan',
                    },
                },
                formatter: 'test',
            },
            dataZoom: [
                {
                    show: true,
                    type: 'inside',
                    filterMode: 'none',
                    xAxisIndex: [0],
                    startValue: 0,
                    endValue: testData.value?.length,
                },
                {
                    show: true,
                    type: 'inside',
                    filterMode: 'none',
                    yAxisIndex: [0],
                },
                {
                    type: 'slider',
                    filterMode: 'filter',
                    show: true,
                    xAxisIndex: [0],
                    startValue: 5000,
                    endValue: 10000,
                    backgroundColor: 'rgba(68, 184, 166, 0.1)',
                    dataBackground: {
                        lineStyle: 'black',
                    },
                    fillerColor: 'rgba(68, 184, 166, 0.1)',
                    borderColor: 'rgba(68, 184, 166, 0.1)',
                    moveHandleStyle: {
                        color: 'darkcyan',
                        shadowColor: 'rgba(68, 184, 166, 0.1)',
                    },
                    showDetail: true,
                    realtime: false,
                    textStyle: {
                        fontWeight: 'bold',
                    },
                },
                {
                    show: false,
                    type: 'inside',
                    yAxisIndex: [0],
                },
            ],
            series: [
                {
                    smooth: 0.1,
                    type: 'line',
                    showSymbol: false,
                    lineStyle: {
                        color: 'darkcyan',
                    },
                    clip: true,
                    data: renderData,
                    label: {
                        position: 'top',
                        show: true,
                    },
                },
            ],
        }
    }, [renderData, testData.value?.length])

    const heartRateOption = useMemo(() => {
        return {
            title: {},
            xAxis: {
                type: 'category',
                data: [],
            },
            yAxis: {
                type: 'value',
            },
            tooltip: {
                show: true,
                trigger: 'axis',

                formatter: 'Heart Rate: {c}',
            },
            series: [
                {
                    data: [80, 82, 84, 84, 85, 82, 78],
                    type: 'line',
                    lineStyle: {
                        color: 'darkcyan',
                    },
                    label: {
                        position: 'top',
                        show: true,
                    },
                },
            ],
        }
    }, [])

    return (
        <div>
            <div className="mb-3">
                <React.Fragment>
                    <div className="grid">
                        <div className="md:col-4 col-12">
                            <div className="flex justify-content-center align-items-center mt-8 mb-5">
                                <div
                                    className="flex justify-content-center align-items-center"
                                    style={{
                                        width: '300px',
                                        height: '300px',
                                        borderRadius: '50%',
                                        backgroundColor:
                                            'rgba(68, 184, 166, 0.8)',
                                    }}>
                                    <div
                                        className="flex justify-content-center align-items-center"
                                        style={{
                                            width: '260px',
                                            height: '260px',
                                            borderRadius: '50%',
                                            backgroundColor:
                                                'rgba(68, 184, 166, 0.6)',
                                        }}>
                                        <div
                                            className="flex justify-content-center align-items-center"
                                            style={{
                                                width: '220px',
                                                height: '220px',
                                                borderRadius: '50%',
                                                backgroundColor:
                                                    'rgba(0, 0, 0, 0.1)',
                                            }}>
                                            <div className="flex justify-content-center align-items-center gap-2">
                                                <h1
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 'bold',
                                                        color: 'white',
                                                        fontSize: '48px',
                                                    }}>
                                                    {96}
                                                </h1>
                                                <div className="flex-column justify-content-center align-items-center">
                                                    <div>
                                                        {' '}
                                                        {translateKeys('BPM')}
                                                    </div>
                                                    <div className="flex justify-content-center align-items-center">
                                                        <BsFillHeartPulseFill
                                                            color="red"
                                                            className="mr-2"
                                                            style={{
                                                                width: '24px',
                                                                height: '24px',
                                                            }}
                                                        />
                                                        <div
                                                            style={{
                                                                color: 'white',
                                                                fontWeight:
                                                                    'bold',
                                                            }}>
                                                            {translateKeys(
                                                                'Normal',
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center">
                                <h4 className="font-bold">
                                    {' '}
                                    {translateKeys('Heart Rate')}
                                </h4>
                                <p>
                                    {translateKeys(
                                        'The average heart rate is calculated from the heart rate data recorded during the ECG measurement.',
                                    )}
                                </p>
                            </div>
                        </div>
                        <div className="md:col-8 col-12">
                            <div>
                                <ReactECharts
                                    style={{height: '50vh'}}
                                    option={heartRateOption}
                                />
                            </div>
                            <p className="text-center">
                                {translateKeys(
                                    'The chart shows the heart rate recorded during measuring the ECG',
                                )}
                            </p>
                        </div>
                    </div>
                </React.Fragment>
            </div>
            <h4 className="font-bold text-center">{translateKeys('ECG')}</h4>
            <ReactECharts
                className="col-12"
                style={{height: '60vh'}}
                option={ecgOption}
            />
        </div>
    )
}

export default ECGChart
